export default "__VITE_ASSET__BTD4asco__"